import { BackendHttpService } from '../../../../../services/backendHttpService';

export class ProjectRolesService extends BackendHttpService {
  private static rolesCache: string[] | null = null;
  private static cacheTimestamp: number = 0;
  private static readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  constructor() {
    super('Project');
  }

  /**
   * Get roles dictionary with caching
   * @returns Promise with array of role names
   */
  async getRolesDictionary(): Promise<string[]> {
    const now = Date.now();
    
    // Return cached data if it's still valid
    if (ProjectRolesService.rolesCache && 
        (now - ProjectRolesService.cacheTimestamp) < ProjectRolesService.CACHE_DURATION) {
      return ProjectRolesService.rolesCache;
    }

    try {
      const roles = await this.get<string[]>('/rolesDictionary');
      
      // Update cache
      ProjectRolesService.rolesCache = roles;
      ProjectRolesService.cacheTimestamp = now;
      
      return roles;
    } catch (error) {
      console.error('Error fetching roles dictionary:', error);
      
      // Return cached data if available, even if expired
      if (ProjectRolesService.rolesCache) {
        return ProjectRolesService.rolesCache;
      }
      
      throw error;
    }
  }

  /**
   * Clear the roles cache (useful for testing or forced refresh)
   */
  static clearCache(): void {
    ProjectRolesService.rolesCache = null;
    ProjectRolesService.cacheTimestamp = 0;
  }
} 